import { createApp } from 'vue';
import MobiToEpubConverter from '@/Components/MobiToEpubConverter.vue';
import '@styles/app.css';

createApp(MobiToEpubConverter).mount('#mobi-to-epub-converter');
